import { useRef } from 'react';
import { useSelector } from 'react-redux';

import Icon from 'components/global/Icon';
import LordIcon from 'components/global/LordIcon';
import Typography from 'components/global/Typography';

import { THEME } from 'utils/Theme';

import * as S from './styled/FormHeader.styled';

/**
 * @author @buunsal
 */

const SubformHeader = ({ icon, boldTitle, lightTitle, lordIcon, className }) => {
	const darkMode = useSelector((state) => state.layout.darkMode);
	const targetRef = useRef(null);

	return (
		<S.HeaderContainer ref={targetRef} className={className}>
			{(lordIcon || icon) && (
				<S.HeaderIconContainer>
					{lordIcon ? (
						<LordIcon
							primaryColor={darkMode ? THEME.WHITE : THEME.BLACK}
							secondaryColor={darkMode ? THEME.DARK.PRIMARY_COLOR : THEME.LIGHT.PRIMARY_COLOR}
							src={lordIcon}
							target={targetRef}
						/>
					) : (
						<Icon icon={icon} size="xx-large" />
					)}
				</S.HeaderIconContainer>
			)}
			<S.Header>
				<Typography noWrap={true} css={S.TitleCss}>
					{boldTitle}
				</Typography>

				<Typography noWrap={true} css={S.SubtitleCss}>
					{lightTitle}
				</Typography>
			</S.Header>
		</S.HeaderContainer>
	);
};

export default SubformHeader;
